import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const TYPE_BADGES = {
  "Internal Audit": { bg: "#DBEAFE", color: "#1E40AF" },
  "External Audit": { bg: "#FEF3C7", color: "#854D0E" },
  "Client Audit": { bg: "#DCFCE7", color: "#166534" },
  "ISO 45001 Audit": { bg: "#DBEAFE", color: "#1E40AF" },
  "Legal Compliance Audit": { bg: "#FFE4E6", color: "#9F1239" },
  "Contractor Audit": { bg: "#F1F5F9", color: "#334155" },
};

const CLASSIF_BADGES = {
  "Major NC": { bg: "#FEE2E2", color: "#7F1D1D" },
  "Minor NC": { bg: "#FEF3C7", color: "#854D0E" },
  Observation: { bg: "#DBEAFE", color: "#1E40AF" },
  OFI: { bg: "#DCFCE7", color: "#166534" },
};

export default function Audits() {
  const { data, siteNames } = useHSE();
  const rows = data.audits || [];
  const intC = rows.filter((a) => a.type === "Internal Audit").length;
  const extC = rows.filter((a) => a.type === "External Audit").length;
  const avgScore = rows.length ? Math.round(rows.reduce((a, b) => a + Number(b.score || 0), 0) / rows.length) : 0;
  const totalFindings = rows.reduce((a, b) => a + Number(b.findings || 0), 0);
  const majorNC = rows.filter((r) => r.classification === "Major NC").length;

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <StatCard label="Internal" value={intC} tone="info" />
      <StatCard label="External" value={extC} tone="warning" />
      <StatCard label="Avg Score" value={`${avgScore}%`} tone={avgScore >= 85 ? "safe" : "warning"} />
      <StatCard label="Total Findings" value={totalFindings} tone="warning" />
      <StatCard label="Major NC" value={majorNC} tone="critical" />
    </div>
  );

  return (
    <RegisterPage
      title="Audit Module"
      subtitle="Internal · External · Client · ISO 45001 · Legal Compliance · Contractor audits"
      storeKey="audits"
      idPrefix="AUD"
      topPanels={Top}
      columns={[
        { key: "id", label: "Audit ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "type", label: "Type" },
        { key: "auditor", label: "Auditor" },
        { key: "auditee", label: "Auditee" },
        { key: "scope", label: "Scope" },
        { key: "criteria", label: "Criteria" },
        { key: "classification", label: "Classification" },
        { key: "findings", label: "Findings" },
        { key: "score", label: "Score", render: (r) => <span className="tabular font-semibold">{r.score}%</span> },
        { key: "ncrRaised", label: "NCRs" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ type: TYPE_BADGES, classification: CLASSIF_BADGES, status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Audit ID" },
        { key: "date", label: "Audit Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "type", label: "Audit Type", type: "select", options: data.settings.auditTypes },
        { key: "auditor", label: "Auditor" },
        { key: "auditee", label: "Auditee / Contractor" },
        { key: "scope", label: "Scope", full: true },
        { key: "criteria", label: "Criteria / Standard" },
        { key: "checklist", label: "Checklist Reference" },
        { key: "classification", label: "Classification", type: "select", options: ["Major NC", "Minor NC", "Observation", "OFI"] },
        { key: "findings", label: "Findings (count)", type: "number" },
        { key: "score", label: "Score (%)", type: "number" },
        { key: "ncrRaised", label: "NCRs Raised", type: "number" },
        { key: "actionRequired", label: "Action Required", type: "select", options: ["Yes", "No"] },
        { key: "responsible", label: "Responsible Person" },
        { key: "dueDate", label: "Due Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed"] },
      ]}
    />
  );
}
